import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;
const actionEndpoint = `${apiUrl}/smq/Action`;

const getResponseData = (response) => {
  const payload = response?.data;

  if (payload?.status === false) {
    throw new Error(payload.message || "Une erreur est survenue");
  }

  return payload;
};

const getErrorMessage = (error) =>
  error?.response?.data?.message ||
  error?.message ||
  "Le service des types d’action est indisponible";

const ActionService = {
  async getAll() {
    try {
      return getResponseData(await axios.get(actionEndpoint));
    } catch (error) {
      throw new Error(getErrorMessage(error));
    }
  },

  async create(action) {
    try {
      return getResponseData(await axios.post(actionEndpoint, action));
    } catch (error) {
      throw new Error(getErrorMessage(error));
    }
  },

  async update(actionId, action) {
    try {
      return getResponseData(
        await axios.put(`${actionEndpoint}/${actionId}`, action)
      );
    } catch (error) {
      throw new Error(getErrorMessage(error));
    }
  },

  async remove(actionId) {
    try {
      return getResponseData(
        await axios.delete(`${actionEndpoint}/${actionId}`)
      );
    } catch (error) {
      throw new Error(getErrorMessage(error));
    }
  },
};

export default ActionService;
